import { render, staticRenderFns } from "./FormQuestionBlockItemSettings.vue?vue&type=template&id=2bde2341"
import script from "./FormQuestionBlockItemSettings.vue?vue&type=script&lang=js"
export * from "./FormQuestionBlockItemSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports